<script setup>
/** 四个关键指标的一排卡片。列表页放 p50/p90，详情页放单个回合的实际时刻。 */
defineProps({
  /** @type {import('vue').PropType<Array<{ key: string, label: string, value: string, hint: string }>>} */
  items: { type: Array, required: true },
})
</script>

<template>
  <ul class="timeline-metrics">
    <li v-for="item in items" :key="item.key" :data-testid="`turn-timeline-metric-${item.key}`">
      <span class="timeline-metrics__label">{{ item.label }}</span>
      <strong class="timeline-metrics__value">{{ item.value }}</strong>
      <span class="timeline-metrics__hint">{{ item.hint }}</span>
    </li>
  </ul>
</template>

<style scoped>
.timeline-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: var(--drama-space-md);
  margin: 0;
  padding: 0;
  list-style: none;
}

.timeline-metrics li {
  display: grid;
  gap: var(--drama-space-xs);
  padding: var(--drama-space-lg);
  border-radius: var(--drama-radius-md);
  background: var(--drama-color-surface-alt);
}

.timeline-metrics__label,
.timeline-metrics__hint {
  color: var(--drama-color-text-muted);
  font-size: var(--drama-font-size-xs);
}

.timeline-metrics__value {
  color: var(--drama-color-text);
  font-size: var(--drama-font-size-2xl, 28px);
  line-height: 1.1;
}

.timeline-metrics__hint {
  overflow-wrap: anywhere;
}

@media (max-width: 880px) {
  .timeline-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
